<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Money Transfer</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-2">
          <v-btn color="primary"  to="/new-account-transfer">
            <v-icon left dark>mdi-plus</v-icon> Create Transfer
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :mobile-breakpoint="zeroValue" :headers="headers" :items="accounts" :search="search">
             <!-- type template -->
             <template v-slot:item.Amount="{ item }">
                <span>{{item.Amount.toLocaleString()}}</span>
              </template>
             <!-- end of type template -->
              <!-- action template -->
              <template v-slot:item.doc_date="{ item }">
                {{ item.doc_date | date }}
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    zeroValue: 0,
    headers: [
      { text: "Amount", value: "amount" },
      { text: "From", value: "fromAccount.Name" },
      { text: "To", value: "toAccount.Name" },
      { text: "Details", value: "desc" },
      { text: "Created By", value: "User.name" },
      { text: "Date", value: "doc_date" },
    ],
    accounts: [],
  }),
  methods: {
    getTransfers() {
      // const data = {
      //   StartDate: null,
      //   EndDate: null
      // };

      const url = "/money-transfers";
      const self = this;
      this.$store
        .dispatch("get", url)
        .then(res => {

          console.log(res, " res");
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getTransfers();
  },
};
</script>